import * as Yup from 'yup';
import { SLUG_MAX_LENGTH } from 'utils/stringUtils';

const SLUG_REGEX = /^[a-z][a-z0-9-]*$/;

export const questionFormSchema = Yup.object({
  label: Yup.string()
    .trim()
    .min(1, 'Required field')
    .max(50, 'Maximum 50 characters')
    .required('Required field'),
  slug: Yup.string()
    .min(1, 'Required field')
    .max(SLUG_MAX_LENGTH, 'Maximum 50 characters')
    .matches(
      SLUG_REGEX,
      'Must start with a letter and contain only lowercase letters, numbers and hyphens'
    )
    .required('Required field'),
});

export const optionFormSchema = Yup.object({
  label: Yup.string()
    .trim()
    .min(1, 'Required field')
    .max(50, 'Maximum 50 characters')
    .required('Required field'),
  slug: Yup.string()
    .min(1, 'Required field')
    .max(SLUG_MAX_LENGTH, 'Maximum 50 characters')
    .matches(
      SLUG_REGEX,
      'Must start with a letter and contain only lowercase letters, numbers and hyphens'
    )
    .required('Required field'),
  price: Yup.number()
    .typeError('Price must be a number')
    .test('twoDecimal', 'Price can only have two decimal places', (value) => {
      if (typeof value !== 'number' || !Number.isFinite(value)) {
        return false;
      }
      return Number(value.toFixed(2)) === value;
    })
    .required('Required field'),
});
